import { Badge, Button, Card, Col, Layout, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import "./Slide.css";
import bodyData from "../../../data/SearchInvoice/body";
import Meta from "antd/es/card/Meta";
import { FireFilled } from "@ant-design/icons";
const MinvoiceProduct: React.FC = () => {
    return (
        <Layout >
            <Content className="minvoice-product-show">
                <Row gutter={16}>
                    {
                        bodyData.MInvoiceProducts.map((minvoiceProduct, index) => (
                            <Col className="minvoice-product-column" key={index} xs={24} sm={8} md={6}>
                                <Card className="minvoice-product-card"
                                    bordered={false}
                                    hoverable
                                    cover={
                                        <img className={`minvoice-product-card-img minvoice-product-card-img-${index}`} alt="example" src={`${process.env.PUBLIC_URL}/${minvoiceProduct.imageUrl}`} />
                                    }
                                    actions={
                                        minvoiceProduct.button.map((minvoiceProductButton, indexButton) => (
                                            <Badge className="minvoice-product-card-button" count={<FireFilled />}>
                                                <Button href={minvoiceProductButton.href} key={indexButton} target="_blank">{minvoiceProductButton.label}</Button>

                                            </Badge>
                                        ))
                                    }
                                >
                                    {
                                        minvoiceProduct.content.map((minvoiceProductContent, indexContent) => (
                                            <Meta className="minvoice-product-card-description" key={indexContent} description={minvoiceProductContent} />
                                        ))
                                    }

                                </Card>
                            </Col>
                        ))
                    }
                </Row>
            </Content>

        </Layout>

    )
}
export default MinvoiceProduct;